import '../css/style.css'

export default function Content() {

    const mainSetup = [
        {
            name: 'Turbo Kompresory',
            class: 'turbo', 
            link: 'https://dwb.com.pl/turbocharger/'
        },
        {
            name: 'Sprężarki Śrubowe',
            class: 'sprezarki', 
            link: 'https://dwb.com.pl/screw_compressors/'
        },
        {
            name: 'Systemy Sterowań',
            class: 'sterowania', 
            link: 'https://dwb.com.pl/control_systems/'
        },
        {
            name: 'Chłodnice',
            class: 'chlodnice', 
            link: 'https://dwb.com.pl/coolers/'
        },
        {
            name: 'Części Zamienne',
            class: 'zamienne',
            link: 'https://dwb.com.pl/spare_parts/'
        },
        {
            name: 'Oferta Pomiarowa',
            class: 'pomiar',
            link: 'https://dwb.com.pl/measurement_offer/'
        }
    ]


    return(
        <div className='content'>
            <div className='head-container'>
                <div className='pdf-container'>
                    <a href="https://dwb.com.pl/new_project/">Nowy projekt - Sterownik sprężarki Centac</a>
                </div>
                <div className='europe-container'>
                    <a href="https://dwb.com.pl/wp-content/uploads/2023/01/6-DWB-9-pol-ang-2022.pdf"><div className='isocert img-europe'/></a>
                    <a href="https://dwb.com.pl/ue_projects/"><div className='europe img-europe'/></a>
                </div>
            </div>
            <div className='select-container'>
                { mainSetup.map(selections => {
                    return(
                        <div className="selection">
                            <a href={ selections.link }>
                                <div className={ `selection-up ${selections.class}` }/>
                                <div className='selection-down'>
                                    <div>{ selections.name }</div>
                                </div>
                            </a>
                        </div>
                    )
                }) }
            </div>
            <div className="adverts">
                <a href="https://dwb.com.pl/used_mp3_panels/">
                    <div className='adv-container'>
                        <div className='adv-up'>Używane panele sterujące MP3</div>
                        <div className='adv-down'>Zobacz zdjęcie</div>
                    </div>
                </a>
                <a href="https://dwb.com.pl/stock_sale/">
                    <div className='adv-container'>
                        <div className='adv-up'>Stany magazynowe</div>
                        <div className='adv-down'>Zobacz zdjęcia</div>
                    </div>
                </a>
            </div>
            <div className='about-container'>
                <div className='about-us'>
                    <div className='about-title'>o firmie</div>
                    <div className='about-content'>DWB-Poland Sp. z o.o. od około 25 lat konsekwentnie rozwija się w zakresie sprężonego powietrza z ukierunkowaniem na dostęp części zamiennych oraz serwisu do turbo kompresoru typu CENTAC® firmy Ingersoll Rand.</div>
                    <a href="https://dwb.com.pl/about_us/">
                        <div className='about-more'>więcej</div>
                    </a>
                </div>
                <div className='about-us'>
                    <div className='about-title'>usługi i serwis</div>
                    <div className='about-content'>Wykorzystując wieloletnie doświadczenie oraz zaplecze sprzętowe oferujemy pełny zakres usług dla użytkowników sprężarek powietrza w celu poprawy niezawodności oraz wydajności maszyn.</div>
                    <a href="https://dwb.com.pl/services/">
                        <div className='about-more'>więcej</div>
                    </a>
                </div>
            </div>
            <div className='dot_container'>
                <img src="https://dwb.com.pl/wp-content/uploads/2024/07/footer.png" alt="footer"/>
            </div>
        </div>
    )
}